module.exports = __webpack_public_path__ + "static/media/627fbb5a-3bae-4cd9-b617-2f923e29d55e.24932ad0.woff2";